import { render, staticRenderFns } from "./JciProgramPaymentReport.vue?vue&type=template&id=5074a381&scoped=true"
import script from "./JciProgramPaymentReport.vue?vue&type=script&lang=js"
export * from "./JciProgramPaymentReport.vue?vue&type=script&lang=js"
import style0 from "./JciProgramPaymentReport.vue?vue&type=style&index=0&id=5074a381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074a381",
  null
  
)

export default component.exports